export default "__VITE_ASSET__BsrS77Ju__"